import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Pillars from "@/components/Pillars";
import About from "@/components/About";
import Services from "@/components/Services";
import ContactCTA from "@/components/ContactCTA";
import Footer from "@/components/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
  useReveal();
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-[#EDEDED]">
      <Nav />
      <Hero />
      <Pillars />
      <About />
      <Services />
      <ContactCTA />
      <Footer />
    </main>
  );
}
